import React from 'react';
import Icon from '../../../components/AppIcon';

const RelatedArticles = ({ articles, onArticleClick }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="mt-48">
      <h2 className="text-2xl font-heading font-bold text-foreground mb-24">
        Related Articles
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
        {articles?.map((article) => (
          <div
            key={article?.id}
            onClick={() => onArticleClick(article?.slug)}
            className="bg-card rounded-lg overflow-hidden shadow-elevation-2 hover:shadow-elevation-3 transition-smooth cursor-pointer group"
          >
            {article?.featuredImageUrl ? (
              <div className="relative h-40 overflow-hidden">
                <img 
                  src={article?.featuredImageUrl} 
                  alt={article?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            ) : (
              <div className="relative h-40 bg-muted flex items-center justify-center">
                <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
              </div>
            )}
            <div className="p-16">
              {article?.categoryName && (
                <span className="inline-block px-8 py-4 bg-primary/10 text-primary text-xs font-medium rounded mb-8">
                  {article?.categoryName}
                </span>
              )}
              <h3 className="text-base font-semibold text-card-foreground mb-8 line-clamp-2 group-hover:text-primary transition-smooth">
                {article?.title}
              </h3>
              <div className="flex items-center gap-8 text-xs text-muted-foreground">
                <Icon name="Calendar" size={12} />
                <span>{formatDate(article?.publishedAt)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;